import React, { useEffect, useState } from 'react';
import { Wrapper03 } from '../../designComponents/wrappers/FlexMainWrapper';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import DesignTable from '../../designComponents/tables/DesignTable';
import { contentFilter, dateFilter, exposureFilter, moneyFilter, roleFilter } from '../../utils/textFilter';
import { NoneUserId } from '../../pages/customerService/CustomerService';
import { DefaultModal } from '../../designComponents/modals/ModalComponent';
import ScheduleDetail from './ScheduleDetail';
import LoadingPage from '../../pages/loading/LoadingPage';

/** 주관 일정 */
const OperateSchedule = ({ userId }) => {
    const [contentInfo, setContentInfo] = useState({ toggle: false });
    const [data, setData] = useState([]);
    const [allCount, setAllCount] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [detailLoading, setDetailLoading] = useState(true);

    useEffect(() => {
        if (userId) {
            const input = {
                userId: userId,
                page: page,
                size: 10,
            };
            setLoading(true);
            const request = RefreshCheckApi.get('/adminGathering/mySchedule/operate', { params: input });
            request.then((res) => {
                setData(res.data.data);
                setAllCount(res.data.allCount);
                setLoading(false);
            });
        } else {
            setData([]);
            setAllCount(0);
            setLoading(false);
        }
    }, [userId, page]);

    return (
        <Wrapper03 style={{ marginBottom: 0, flex: 1 }}>
            {contentInfo.toggle && (
                <DefaultModal
                    title={'참여 일정 상세정보'}
                    boxStyle={{ width: '100vh', height: '70vh' }}
                    onClickClose={() => setContentInfo({ toggle: false })}
                    closeOn={true}
                    onClickBottomClose={() => setContentInfo({ toggle: false })}
                >
                    {detailLoading ? <LoadingPage text={'일정 상세정보를 불러오고 있습니다.'} /> : <ScheduleDetail data={contentInfo.contentDetail} />}
                </DefaultModal>
            )}
            <MainPageTitle wrapperStyle={{ margin: 0 }} fontStyle={{ fontSize: '17px', fontWeight: 600, color: '#797979' }} text={'운영 일정'} />
            {userId ? (
                <DesignTable
                    loading={loading}
                    marginTop={2}
                    onToggle={null}
                    modalComponent={false}
                    header={[
                        { title: '생성일', width: 135 },
                        { title: '모임명', width: 200 },
                        { title: '모임장명', width: 80 },
                        { title: '일정명', width: 200 },
                        { title: '참여 인원', width: 70 },
                        { title: '참여 금액', width: 70 },
                        { title: '일정 설명', width: 500 },
                    ]}
                    onClick={async (item) => {
                        try {
                            setDetailLoading(true);
                            const url = `/adminGathering/mySchedule/join/detail?content_id=${item.content_id}`;
                            const response = await RefreshCheckApi.get(url);
                            if (response.status === 200) {
                                setContentInfo({
                                    toggle: true,
                                    content_id: item.content_id,
                                    contentDetail: response.data.data,
                                });
                                setDetailLoading(false);
                            }
                        } catch (error) {
                            alert('[Error]관리자에게 문의하세요.');
                            console.error(error);
                        }
                    }}
                    body={[
                        { key: 'created_at', width: 135 },
                        { key: 'gathering_name', width: 200 },
                        { key: 'owner_name', width: 80 },
                        { key: 'schedule_name', width: 200 },
                        { key: 'join_count', width: 70 },
                        { key: 'price', width: 70 },
                        { key: 'schedule_content', width: 500 },
                    ]}
                    data={data}
                    allCount={allCount}
                    page={page}
                    setPage={setPage}
                    bodyRederItem={(key, value) => {
                        if (key === 'gathering_name') return contentFilter(value);
                        if (key === 'created_at') return dateFilter(value);
                        if (key === 'role') return roleFilter(value);
                        if (key === 'exposure_yn') return exposureFilter(value);
                        if (key === 'schedule_name') return contentFilter(value, 10);
                        if (key === 'price') return moneyFilter(value) + '원';
                        if (key === 'schedule_content') return contentFilter(value, 50);
                        return value;
                    }}
                    noneText="운영중인 일정 내역이 존재하지 않습니다."
                    noneHieght={27}
                />
            ) : (
                <NoneUserId text="회원을 선택해 주세요." />
            )}
        </Wrapper03>
    );
};

export default OperateSchedule;
